"use client"
import Image from "next/image"
import IconZalo from "@/assets/icon_zalo.webp"

export default function FloatingZaloButton() {
  return (
    <div className="fixed bottom-6 left-6 z-1000">
      <button
        onClick={() => window.open("https://zalo.me/0902855892")}
        className="w-12 h-12 rounded-full shadow-lg transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white" // Adjusted styling for image
        aria-label="Chat Zalo"
        type="button"
      >
        <Image
          src={IconZalo}
          alt="Zalo icon"
          width={48}
          height={48}
          className="w-full h-full object-contain"
        />
      </button>
    </div>
  )
}
